import React from 'react';

// Import sub-components
import TicketHeader from './TicketHeader';
import TicketStatusChips from './TicketStatusChips';
import BasicInformationSection from './BasicInformationSection';
import CategorySpecificSection from './CategorySpecificSection';
import ICTSupportSection from './ICTSupportSection';
import StatusMessageSection from './StatusMessageSection';

const TicketDetails = ({ 
  ticket, 
  loading, 
  handleDownload 
}) => {
  if (loading) {
    return (
      <div className="mt-6">
        <div className="p-8 rounded-xl text-center shadow-lg bg-white">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-6"></div>
          <h3 className="text-lg font-semibold text-blue-600 mb-2 font-poppins">
            Tracking Your Ticket
          </h3>
          <p className="text-slate-600 font-poppins">
            Please wait while we fetch your ticket details...
          </p>
        </div>
      </div>
    );
  }

  if (!ticket) return null;

  return (
    <div className={`mt-6 transition-all duration-500 ease-in-out ${ticket ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'}`}>
      <div className="p-6 rounded-xl bg-gradient-to-br from-white to-slate-50 border border-blue-500/10 shadow-lg relative overflow-hidden before:content-[''] before:absolute before:top-0 before:left-0 before:right-0 before:h-1 before:bg-gradient-to-r before:from-blue-600 before:via-blue-500 before:to-cyan-400">
        {/* Header with Tracking ID */}
        <TicketHeader ticket={ticket} />

        {/* Status and Priority Chips */}
        <TicketStatusChips ticket={ticket} />

        {/* Basic Information Section */}
        {ticket.status !== 'RESOLVED' && (
          <BasicInformationSection ticket={ticket} />
        )}

        {/* Category Specific Details */}
        {ticket.categorySpecificDetails && ticket.status !== 'RESOLVED' && (
          <CategorySpecificSection 
            ticket={ticket} 
            loading={loading}
            handleDownload={handleDownload}
          />
        )}

        {/* ICT Support Information */}
        {(ticket.status === 'IN_PROGRESS' || (ticket.status === 'RESOLVED' && ticket.category !== 'ACCOUNT_MANAGEMENT')) && (
          <ICTSupportSection ticket={ticket} />
        )}

        {/* Status-specific messages */}
        <StatusMessageSection ticket={ticket} />
      </div>
    </div>
  );
};

export default TicketDetails;